export default __webpack_public_path__ + "d757c535a2e5902f1325192d99e0c965.woff";